module.exports = __webpack_public_path__ + "static/media/icon_linked_in.9e44f688.svg";